import React from 'react'

export const Locationbillingdetails = () => {
  return (
    <div>Locationbillingdetails</div>
  )
}
